<template>
    <div style="animation: fadein .35s ease;">
        <!-- os links da unidade são exibidos no menu lateral (menu-lateral-unidade) -->
        <slot name="conteudo">
        </slot>
        <slot name="rodape">
        </slot>
    </div>
</template>

<script>
export default {
    props:{
        unitie:{
            type:Object,
            required:true
        },
        linkUnidade:{
            type:String,
            required:true
        },
        usuarioLogado:{
            type:Object,
            required:true
        }
    },
    data(){
        return{
            unities_users:{}
        }
    },
    computed:{
        // perfis 1 e 2 (administradores) veem tudo que a unidade oferece;
        // perfil 3 depende também da permissão do usuário na unidade
        podeProcessoSeletivo(){
            return this.unitie.oferta_processo_seletivo==1 && (this.ehAdministrador || this.unities_users.oferta_processo_seletivo==1)
        },
        podeInscricaoWeb(){
            return this.unitie.oferta_Inscricao_web==1 && (this.ehAdministrador || this.unities_users.oferta_Inscricao_web==1)
        },
        ehAdministrador(){
            return this.usuarioLogado.perfil_usuario==1 || this.usuarioLogado.perfil_usuario==2
        },
        temAcesso(){
            return this.ehAdministrador || this.usuarioLogado.perfil_usuario==3
        },
        menu(){
            const base = '/Access/Unity/Unitie/'+this.unitie.id

            if(!this.temAcesso){
                return null
            }

            const links = [
                { titulo:'Dashboard da Unidade', icone:'fa-solid fa-chart-line', href: base, exato:true },
                { titulo:'Oferta de Processo Seletivo', icone:'fa-solid fa-clipboard-list', href: base+'/oferta_processo_seletivo', visivel:this.podeProcessoSeletivo },
                { titulo:'Oferta de Inscrição Web', icone:'fa-solid fa-globe', href: base+'/oferta_inscricao_web', visivel:this.podeInscricaoWeb },
                { titulo:'WebHooks', icone:'fa-solid fa-satellite-dish', href: base+'/captacao' },
            ].filter(link => link.visivel !== false)

            const configuracoes = [
                { titulo:'Financeiro Inscrições', icone:'fa-solid fa-sack-dollar', href: base+'/oferta_inscricao_web/conf/financeira', visivel:this.podeInscricaoWeb },
                { titulo:'Financeiro Processo Seletivo', icone:'fa-solid fa-coins', href: base+'/oferta_processo_seletivo/conf/financeira', visivel:this.podeProcessoSeletivo },
                { titulo:'Configurações da Unidade', icone:'fa-solid fa-gear', href: base+'/config' },
            ].filter(link => link.visivel !== false)

            return { id: this.unitie.id, nome: this.unitie.nomecompleto, links, configuracoes }
        }
    },
    watch:{
        menu:{
            immediate:true,
            handler(menu){
                if(this.$store){
                    this.$store.commit('definirMenuUnidade', menu)
                }
            }
        }
    },
    created(){
        for(let i=0;i<this.unitie.unities_users.length;i++){
            if(this.usuarioLogado.id==this.unitie.unities_users[i].user_id){
                this.unities_users = this.unitie.unities_users[i]
            }
        }
    }
}
</script>
